<ng-content select="span"></ng-content>
<ng-content></ng-content>